import * as React from 'react';

import classNames from 'classnames';

import {Button} from 'shells/button/button';
import {CardWidget} from 'shells/card/card-widget/card-widget';
import type {
    AddButtonProps as CardWidgetAddButtonProps,
    ErrorProps as CardWidgetErrorProps,
} from 'shells/card/card-widget/card-widget';

import {useGetSessionUser} from '../use-get-session-user';

import {useCollapsible, getWidgetTitle, getWidgetEmptyStateProps} from './helpers';
import type {CardWidgetKey} from './types';

type Props = {
    children: React.ReactNode | null | undefined;
    secondaryTitle?: React.ReactNode;
    upperCaseTitle?: boolean;
    addButtonProps?: CardWidgetAddButtonProps;
    errorProps?: CardWidgetErrorProps;
    widgetKey: CardWidgetKey;
    count?: number;
    collapsedContent?: React.ReactNode;
    isFullWidth?: boolean;
    isFullHeight?: boolean;
    isLoading?: boolean;
    minExpandedHeight?: number;
    secondaryExpandProps?: {
        text: string;
        marginTop?: 8 | 16;
    };
    isEmpty?: boolean;
    rowsHavePadding?: boolean;
};

/* DEPRECATED: use CollapsibleCardWidget instead. */
export function CardWidgetWrapper(props: Props) {
    const {
        widgetKey,
        collapsedContent,
        count,
        secondaryExpandProps,
        isEmpty,
        addButtonProps,
        ...restProps
    } = props;

    const {user} = useGetSessionUser();
    const {isCollapsed, onChange} = useCollapsible(widgetKey, user);

    let fullCollapsedContent = collapsedContent;

    if (secondaryExpandProps) {
        const secdonaryExpandClassNames = classNames('flex justify-center', {
            'mt-8': secondaryExpandProps.marginTop === 8,
            'mt-16': secondaryExpandProps.marginTop === 16,
        });

        fullCollapsedContent = (
            <>
                {collapsedContent}
                <div className={secdonaryExpandClassNames}>
                    <Button
                        variant='text-secondary-dark'
                        noPadding={true}
                        onClick={onChange}
                        size='small'
                    >
                        {secondaryExpandProps.text}
                    </Button>
                </div>
            </>
        );
    }

    return (
        <CardWidget
            {...restProps}
            title={getWidgetTitle(widgetKey, count)}
            collapsibleProps={{
                isCollapsed: isCollapsed,
                onToggle: onChange,
                collapsedContent: fullCollapsedContent,
            }}
            addButtonProps={addButtonProps}
            emptyStateProps={getWidgetEmptyStateProps(widgetKey, Boolean(isEmpty))}
        />
    );
}
